<template>
  <v-list>
    <v-list-item
      v-for="(email, i) in fornecedorEnvio.emails"
      :key="i"
      :value="email"
      color="primary">
      <v-list-item-title>
        {{ email | naoInformado }}
      </v-list-item-title>
      <v-list-item-action v-if="hasRoleComprador">
        <v-btn icon small @click="remove(email)">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
    <v-list-item v-if="!fornecedorEnvio.emails.length">
      <v-list-item-title class="texto">
        Nenhum E-mail encontrado
      </v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import GestaoFornecedorService from '../../../gestao-fornecedor-service';

export default {
  props: {
    hasRoleComprador: Boolean,
    fornecedor: Object,
  },
  data() {
    return {
      fornecedorEnvio: {
        emails: [],
      },
    };
  },
  methods: {
    remove(item) {
      const fornecedor = { ...this.fornecedorEnvio };
      fornecedor.emails = fornecedor.emails.filter(email => email !== item);
      this.save(fornecedor);
    },
    save(fornecedor) {
      GestaoFornecedorService.updateEmail(this.fornecedor.id, fornecedor)
        .then(() => {
          this.$toast('Email removido', { color: 'success' });
          this.getEmails();
        });
    },
    getEmails() {
      GestaoFornecedorService.get(this.fornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedorEnvio.emails = fornecedor.emails;
        });
    },
  },
  created() {
    this.getEmails();
  },
};
</script>
<style scoped>
.texto{
  font-size: 0.9rem;
}

</style>
